var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"auth-layout"}},[_c('div',{staticClass:"router-view-area"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }